export const allCypherVersions = ['CYPHER 5', 'CYPHER 25'];
export const cypherVersionNumbers = ['5', '25'];
//# sourceMappingURL=types.js.map